import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FormItemModel } from "services/models/form-builder/form-item.model";

@Component({
  selector: "app-form-input-select",
  template: `
    <ng-select
      *ngIf="item.inputType === 'SELECT'"
      [formControl]="control"
      placeholder="Selecione"
      [disabled]="readonly"
      [items]="item.options"
      bindLabel="label"
      bindValue="label"
      [ngbTooltip]="selectedLegend"
    >
      <ng-template ng-option-tmp let-item="item" let-index="index">
        <span container="body" [ngbTooltip]="item.legend">
          {{ item.label }}
        </span>
      </ng-template>
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span container="body" [ngbTooltip]="item.legend">
          {{ item.label }}
          <span
            (click)="clear(item)"
            class="ng-value-icon left"
            aria-hidden="true"
            >×</span
          >
        </span>
      </ng-template>
    </ng-select>

    <ng-select
      *ngIf="item.inputType == 'MULTISELECT'"
      [formControl]="control"
      placeholder="Selecione"
      [disabled]="readonly"
      [multiple]="true"
      [items]="item.options"
      bindLabel="label"
      bindValue="label"
    >
      <ng-template ng-option-tmp let-item="item" let-index="index">
        <span container="body" [ngbTooltip]="item.legend">
          {{ item.label }}
        </span>
      </ng-template>
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span container="body" [ngbTooltip]="item.legend">
          {{ item.label }}
          <span
            (click)="clear(item)"
            class="ng-value-icon left"
            aria-hidden="true"
            >×</span
          >
        </span>
      </ng-template>
    </ng-select>
  `,
})
export class FormInputSelectComponent implements OnInit {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() readonly: boolean = false;

  ngOnInit() {
    this.syncDisabledState();

    if (!this.readonly && !this.control.value) {
      this.control.setValue(null);
    }

    if (this.readonly && this.item.inputType === "MULTISELECT") {
      const value =
        this.control.value.split(";").filter((f: string) => !!f) || [];
      this.control.setValue(value);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["readonly"]) {
      this.syncDisabledState();
    }
  }

  public get selectedLegend(): string {
    const selectedValue = this.control.value;
    const selectedOption = this.item.options?.find(
      (opt) => opt === selectedValue || opt.label === selectedValue
    );
    return selectedOption?.legend || "";
  }

  private syncDisabledState(): void {
    if (!this.control) return;
    if (this.readonly && !this.control.disabled) {
      this.control.disable({ emitEvent: false });
    } else if (!this.readonly && this.control.disabled) {
      this.control.enable({ emitEvent: false });
    }
  }
}
